import React from 'react';
import AnimatedNumber from 'animated-number-react';

import { useStyles } from './styles';
import Typography from '@material-ui/core/Typography';
import { CircularProgress } from '@material-ui/core';
import { formatNumber } from 'features/dashboard/utils/formatNumber';
import i18n from 'locales/i18n';

type TotalInfoItemProps = {
  isLoading: boolean;
  title: string;
  quantity: number;
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
};

const TotalInfoItem = ({ isLoading, title, quantity, icon: IconComponent }: TotalInfoItemProps) => {
  const direction = i18n.dir()

  const classes = useStyles({ direction });

  return (
    <div className={classes.totalInfoContainer}>
      <div>
        <Typography variant="body2" color="textSecondary">
          {title}
        </Typography>
        {isLoading ? (
          <CircularProgress size={30} thickness={1} color="primary" />
        ) : (
          <Typography variant="h3">
            <AnimatedNumber value={quantity} formatValue={formatNumber} />
          </Typography>
        )}
      </div>
      <IconComponent />
    </div>
  );
};

export default TotalInfoItem;
